import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIHeading1 } from '@cian/ui-kit';

import * as React from 'react';
import DOMPurify from 'isomorphic-dompurify';

import { DATA_AS_NAV_TAB_ATTR } from '../Header/helpers/mapClausesToTabs';

import * as styles from './SectionBlock.css';

type LayoutBlockProps = {
  sectionTabTitle?: string;
  title?: string;
  /** @description Поддерживает html, санитайзит строку */
  description?: string;
  id: string;
  children: React.ReactNode | React.ReactNode[];
  onView?: () => void;
};

export const SectionBlock: React.FC<LayoutBlockProps> = ({
  title,
  id,
  children,
  onView,
  sectionTabTitle,
  description,
}) => {
  const sanitizedDescription = React.useMemo(() => description && DOMPurify.sanitize(description), [description]);

  const tabAttributes = sectionTabTitle ? { [DATA_AS_NAV_TAB_ATTR]: sectionTabTitle } : null;

  const content = (
    <section id={id} className={styles['container']} {...tabAttributes}>
      {title && (
        <div data-testid={`${id}-header`}>
          <div className={styles['title-container']} data-testid={`${id}-header--title-container`}>
            <UIHeading1 data-testid={`${id}-header--title`}>{title}</UIHeading1>
            {sanitizedDescription && (
              <div
                className={styles['header-description']}
                data-testid={`${id}-header--description`}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
              />
            )}
          </div>
        </div>
      )}
      <div data-testid={`${id}-content`}>{children}</div>
    </section>
  );

  if (onView) {
    return (
      <ActionAfterViewObserver callback={onView} triggerOnce>
        {content}
      </ActionAfterViewObserver>
    );
  }

  return content;
};
